const { createSlice } = require('@reduxjs/toolkit');
export const storeData = async (key, value) => {
	try {
		const jsonValue = JSON.stringify(value);
		sessionStorage.setItem(`${key}`, jsonValue);
	} catch (e) {
		// saving error
	}
};

export const getData = async (key) => {
	try {
		const jsonValue = sessionStorage.getItem(`${key}`);
		return jsonValue != null ? JSON.parse(jsonValue) : null;
	} catch (e) {
		// error reading value
	}
};

const UiReducer = createSlice({
	name: 'ui',
	initialState: {
		loginModal: false,
		enquiryModal: false,
	},

	reducers: {
		toggleLoginModal(state, action) {
			state.loginModal = action.payload;
		},
		toggleEnquiryModal(state, action) {
			state.enquiryModal = action.payload;
		},
	},
});

const { actions } = UiReducer;

export const { toggleLoginModal, toggleEnquiryModal } = actions;

export default UiReducer;
